<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="edward">
<h1 style="margin-top:150px;">Edward</h1>
<p><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0cea878d